import type { AppConfigurationDto } from "src/app/features/ApplicationConfigurations/types/AppConfigurationDto";
import type { AppConfigurationEntity } from "src/app/features/ApplicationConfigurations/types/AppConfigurationEntity";
import { getAssignedDataGroup } from "../../../../../core/router/auth";

export const AppConfigurationEntityToDto = (appConfigurationModel: AppConfigurationEntity): AppConfigurationDto => {
    const dataGroup = getAssignedDataGroup();
    const dataGroupCode = dataGroup?.code;
    return {
        applicationConfiguration: JSON.stringify(appConfigurationModel),
        dataGroupCode: String(dataGroupCode),
    };
};
